import React, { useEffect } from "react";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setIsOpenInDialog,
  setIsOpenOutDialog,
  setIsOpenExchangeDialog,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/DrawerSlice";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";

import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import DrawerAmountListing from "./DrawerAmountListing";
import {
  useDrawerInOutMutation,
  useGetAllDrawerDataQuery,
} from "src/services/DrawerService";
import DrawerInFormWrapper from "../InOutFlow/DrawerInFormWrapper";
import DrawerOutFormWrapper from "../InOutFlow/DrawerOutFlowWrapper";
import DrawerExchangeFormWrapper from "../Exchange/DrawerExchangeFormWrapper";

type Props = {};

const DrawerAmountListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    isOpenInDialog,
    isOpenOutDialog,
    isOpenExchangeDialog,
    isTableLoading,
  } = useSelector((state: RootState) => state.drower);

  const { data, isLoading, isFetching } = useGetAllDrawerDataQuery("");
  const [withdrawalDrawer] = useDrawerInOutMutation();
  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const WithdrawalPayment = (totalAmount: number) => {
    showConfirmationDialog({
      title: "Heads Up",
      text: "Are you sure you want to withdraw all drawer payments?",
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          withdrawalDrawer({ type: "WITHDRAWL" }).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

  const cashColumns: columnTypes[] = [
    {
      field: "name",
      headerName: "Currency Note Value",
      flex: "flex-[1_1_0%]",
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: "flex-[1_1_0%]",
      align: "center",
    },
    {
      field: "totalAmt",
      headerName: "Total Amount",
      flex: "flex-[1_1_0%]",
      align: "end",
      renderCell: (row: any) => Number(row.totalAmt || 0).toLocaleString("en-IN"),
    },
  ];
  const onlineColumns: columnTypes[] = [
    {
      field: "name",
      headerName: "Payment Mode",
      flex: "flex-[1_1_0%]",
    },
    {
      field: "totalAmt",
      headerName: "Total Amount",
      flex: "flex-[1_1_0%]",
      align: "end",
      renderCell: (row: any) => Number(row.totalAmt || 0).toLocaleString("en-IN"),
    },
  ];

  return (
    <>
      {" "}
      <div>
        <DrawerAmountListing
          onlineColumns={onlineColumns}
          cashColumns={cashColumns}
          rows={items}
          withdrawl={WithdrawalPayment}
          paginationProps={{
            isTableLoading,
           
            setIsOpenInDialog: (value) => dispatch(setIsOpenInDialog(value)),
            setIsOpenOutDialog: (value) => dispatch(setIsOpenOutDialog(value)),
            setIsOpenExchangeDialog: (value) =>
              dispatch(setIsOpenExchangeDialog(value)),
          }}
        />
      </div>
      {isOpenInDialog ? <DrawerInFormWrapper /> : null}
      {isOpenOutDialog ? <DrawerOutFormWrapper /> : null}
      {isOpenExchangeDialog ? <DrawerExchangeFormWrapper /> : null}
    </>
  );
};

export default DrawerAmountListingWrapper;
